export default "__VITE_ASSET__a88ae1f1__"